module.exports = __webpack_public_path__ + "media/ibd.61e3ec78.wav";